// Portuguese date formatting (dd/mm/aaaa) for the finance pages.
// DateOnly strings ("2026-01-15") and the date part of DateTime strings
// ("2026-01-15T00:00:00") are read as local dates, so they never shift a day.

function toDate(value: string | Date | null | undefined): Date | null {
  if (value == null || value === '') return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const m = /^(\d{4})-(\d{2})-(\d{2})(T00:00:00(\.0+)?Z?)?$/.exec(value);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

export function formatDate(value: string | Date | null | undefined): string {
  const d = toDate(value);
  if (!d) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// Short label for chart axes, e.g. "15 jan".
export function formatShortDate(value: string | Date | null | undefined): string {
  const d = toDate(value);
  if (!d) return '';
  return d.toLocaleDateString('pt-PT', { day: 'numeric', month: 'short' });
}
